import { gql } from '__generated__'

export const GetStartDateOptions = gql(/* GraphQL */ `
    query getStartDateOptions {
        candidateStartDates
    }
`)

export const GetRosterStartDateOptions = gql(/* GraphQL */ `
    query getRosterStartDateOptions {
        rosterStartDates
    }
`)
